import { env } from '@/core/env';

export const ORIENTATION_TOUR_ID = 'tour.orientation' as const;
export const GET_STARTED_CHECKLIST_ID = 'checklist.get-started' as const;

export const GET_STARTED_TASK = {
  wsLocation: 'ws.location',
  wsProduct: 'ws.product',
  wsGoogle: 'ws.google',
  wsInvite: 'ws.invite',
  meProfile: 'me.profile',
  meCard: 'me.card',
  meTour: 'me.tour',
  meShare: 'me.share',
} as const;

export type GetStartedTaskId =
  (typeof GET_STARTED_TASK)[keyof typeof GET_STARTED_TASK];

/** Stable hint IDs — do not rename without a progress migration. */
export const HINT_ID = {
  navProducts: 'hint.nav-products',
  profilesEmpty: 'hint.profiles-empty',
  profileLinkCard: 'hint.profile-link-card',
  shareProfile: 'hint.share-profile',
  productsEmpty: 'hint.products-empty',
  liveScan: 'hint.live-scan',
  locationsEmpty: 'hint.locations-empty',
  leadsInbox: 'hint.leads-inbox',
  peopleInvite: 'hint.people-invite',
  reputationSetup: 'hint.reputation-setup',
} as const;

export type HintId = (typeof HINT_ID)[keyof typeof HINT_ID];

export const GUIDANCE_TARGET = {
  welcomeHost: 'welcome-host',
  home: 'home',
  profiles: 'profiles',
  leads: 'leads',
  /** Leads page scope + list/board row (orientation tour). */
  leadsToolbar: 'leads-toolbar',
  more: 'more',
  checklistLauncher: 'checklist-launcher',
  navProducts: 'nav-products',
  profilesEmpty: 'profiles-empty',
  profileLinkCard: 'profile-link-card',
  shareProfile: 'share-profile',
  productsEmpty: 'products-empty',
  liveScan: 'live-scan',
  locationsEmpty: 'locations-empty',
  leadsInbox: 'leads-inbox',
  peopleInvite: 'people-invite',
  reputationSetup: 'reputation-setup',
} as const;

export type GuidanceTarget =
  (typeof GUIDANCE_TARGET)[keyof typeof GUIDANCE_TARGET];

export function guidanceTargetSelector(target: GuidanceTarget): string {
  return `[data-guidance-target="${target}"]`;
}

export function welcomeVideoUrl(): string {
  return env.VITE_GUIDANCE_WELCOME_VIDEO_URL ?? '';
}
